import { useEffect, useState } from "react";
import { getPrincipalMessage } from "../Service/Api"; 
import Breadcrumb from '../Component/Breadcrumb'
import LazyLoad from "react-lazyload";
const removeHtmlTags = (str) => {
  return str.replace(/<[^>]*>/g, ''); // Removes anything between '<' and '>'
};
const Headgirl = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      setData(messages);
    };
    fetchData();
  }, []);
  const emptyArray = [
    // { description: "“Educating the mind without educating the heart is no education at all.” Sacred Heart has been educating boys and girls since 1990; though much has changed over the years our mission remains the same. Sacred Heart is committed to developing students of high academic achievement, intellectual curiosity, and strong moral character. As a result, year after year Sacred Heart sends our respectful, responsible and compassionate young adults, who are well prepared to tackle the challenges that lay ahead. Since arriving at Sacred Heart in 2016, I have had the opportunity to observe this unique institution up close. I have seen its commitment to academic excellence, its dynamic student body, and incredibly committed faculty and a loving community where the students and families are proud and supportive of one another. As I walk down the hallways of the school every day, I can hear the chatter of eager minds; the shouts of excitement from the victorious athletes, the thumb of dancers feed and the sound of melodious voices harmonizing the perpetual energy, movement and enthusiasm permeate the atmosphere. Ours is a school with difference. We value creativity and innovation and strive to nurture them in our students. Sacred Heartians are groomed to become confident, articulate and enlightened young citizens ready to step into the global society with dignity, honour and integrity. Aristotle once said “Educating the mind without educating the heart is no education at all”. Even as we impart education to match the advancement in technology and globalization, we march our children ahead with Sacred Heart ethos of moral values and principles. We Endeavour constantly to instill these qualities in our children. We pride ourselves to help them grow and develop into sensitive, responsible God loving citizens of the future. May the Sacred Heart of Jesus bless us abundantly in all our endeavourers.", attachments: "director.jpg" },   
  ];
  return (
    <>
      <Breadcrumb breadtitle="Head Girl's Message" breadmid="About" breadend="Head Girl's Message" />
      <div className="innerpage">

        <div className="container">

          {data?.length > 0 ? data?.filter((div) => div.category === "HeadGirl").map((item, index) => (
            <div className="row message_inner" key={index}>
              <div className="col-lg-4 col-md-4">
                <LazyLoad><img src={`https://webapi.entab.info/api/image/${item.attachments}`} className="inner_img img-fluid" alt="Cannosa School, Lucknow" /></LazyLoad>
              </div>
              <div className="col-lg-8 col-md-8 messagebox">
                <p>{removeHtmlTags(item.message)}</p>
                <h5 className="mb-0">{item.name} </h5>
                <h5><span> {item.category} </span></h5><div className="clr"></div>
              </div>
            </div>
          ))  : ( 
            <div className="row message_inner">
              <div className="col-lg-4 col-md-4">
                <LazyLoad><img src="https://webapi.entab.info/api/image/CSFL/public/images/headgirl.png" className="inner_img img-fluid" alt="Canossa School, Lucknow" /></LazyLoad>
              </div>
              <div className="col-lg-8 col-md-8 messagebox">
              <p>Dear school community,</p>
<p>I am indeed filled with profound gratitude to serve as head girl of this reputed and prestigious institute. Whenever I look over my journey from nursery to 12, it always fills me with great honour and gratitude. From the moment I stepped in, I was nurtured with love, promise, education, values and challenges.</p>
<p>Not only education but this school has inlisted me with perseverance, integrity, confidence, courage and empathy. Canossa school has been a place where I discovered my passions, paved path for my dreams and cultivated beautiful memories. I wholeheartedly appreciate and thank our respected teachers for their unwavering support and motivation in every single aspect, the supporting staff for their seamless effort to make every event a success.</p>

<p>Canossa's serene environment has always foster a sense of connection and belongingness, where dreams and passion takes flight. Let's continue to uphold the canossian legacy and it’s flag high in sky with respect and pride.</p>
<br />
<p>With sincere regards</p>
                <h5 className="mb-0">Ananya Dwivedi  </h5>
                <h5><span>Head Girl</span></h5>
                <div className="clr"></div>
              </div>
            </div> 
          )
          }
        </div>
      </div>
    </>
  )
}

export default Headgirl
